package com.islamicmedia.site.components

import androidx.compose.runtime.*
import com.islamicmedia.site.theme.*
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ErrorReportModal(
    message: String,
    onDismiss: () -> Unit,
    onSubmit: (String) -> Unit
) {
    var userMessage by remember { mutableStateOf("") }
    var submitted by remember { mutableStateOf(false) }

    // Overlay backdrop
    Div(attrs = {
        style {
            position(Position.Fixed)
            top(0.px)
            left(0.px)
            right(0.px)
            bottom(0.px)
            backgroundColor(rgba(0, 0, 0, 0.5))
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            property("justify-content", "center")
            property("z-index", "1000")
        }
        onClick { onDismiss() }
    }) {
        // Modal card
        Div(attrs = {
            style {
                backgroundColor(Color.white)
                borderRadius(24.px)
                padding(28.px)
                property("max-width", "420px")
                width(90.percent)
                property("box-shadow", "0 20px 60px rgba(0,0,0,0.2)")
                property("text-align", "center")
            }
            onClick { it.stopPropagation() }
        }) {
            if (!submitted) {
                // Title
                Div(attrs = {
                    style {
                        fontSize(22.px)
                        fontWeight(700)
                        color(Primary)
                        marginBottom(8.px)
                    }
                }) { Text("Oops!") }

                // Message
                P(attrs = {
                    style {
                        fontSize(14.px)
                        color(Gray600)
                        lineHeight(1.5.em)
                        margin(0.px, 0.px, 16.px)
                    }
                }) { Text(message) }

                // Text area
                TextArea(attrs = {
                    placeholder("What were you trying to analyze? Any other details that might help us...")
                    onInput { userMessage = it.value }
                    style {
                        width(100.percent)
                        property("min-height", "100px")
                        padding(12.px)
                        fontSize(13.px)
                        borderRadius(12.px)
                        property("border", "1px solid $Gray300")
                        property("outline", "none")
                        property("resize", "vertical")
                        property("font-family", "inherit")
                        property("box-sizing", "border-box")
                    }
                })

                // Buttons
                Div(attrs = {
                    style {
                        display(DisplayStyle.Flex)
                        gap(12.px)
                        marginTop(16.px)
                    }
                }) {
                    // Dismiss
                    Button(attrs = {
                        onClick { onDismiss() }
                        style {
                            property("flex", "1")
                            padding(10.px, 16.px)
                            fontSize(14.px)
                            fontWeight(500)
                            color(Gray500)
                            backgroundColor(Color.white)
                            property("border", "1px solid $Gray300")
                            borderRadius(12.px)
                            property("cursor", "pointer")
                        }
                    }) { Text("Dismiss") }

                    // Send Report
                    Button(attrs = {
                        onClick {
                            onSubmit(userMessage)
                            submitted = true
                        }
                        style {
                            property("flex", "1")
                            padding(10.px, 16.px)
                            fontSize(14.px)
                            fontWeight(600)
                            color(Color.white)
                            backgroundColor(Primary)
                            property("border", "none")
                            borderRadius(12.px)
                            property("cursor", "pointer")
                        }
                    }) { Text("Send Report") }
                }
            } else {
                // Thank you state
                Div(attrs = {
                    style {
                        fontSize(22.px)
                        fontWeight(700)
                        color(Primary)
                        marginBottom(8.px)
                    }
                }) { Text("Thank you!") }

                P(attrs = {
                    style {
                        fontSize(14.px)
                        color(Gray600)
                        lineHeight(1.5.em)
                        margin(0.px, 0.px, 16.px)
                    }
                }) { Text("Your report has been sent. We'll look into this right away.") }

                Button(attrs = {
                    onClick { onDismiss() }
                    style {
                        padding(10.px, 24.px)
                        fontSize(14.px)
                        fontWeight(600)
                        color(Color.white)
                        backgroundColor(Primary)
                        property("border", "none")
                        borderRadius(12.px)
                        property("cursor", "pointer")
                    }
                }) { Text("Close") }
            }
        }
    }
}
